/* BLANC SPACE: customer photos and videos at the end of the product gallery
   (2026-10-08, Scott). Fills the seven hidden [data-bs-review] cells that
   snippets/product-gallery.liquid renders for products carrying the
   `blancspace.gallery_reviews` metafield, from this product's own Loox media
   pool (the same fetch the review grid and video rail use - started early
   here). Videos autoplay muted in place, square-cropped, and a maximise
   control opens the shared viewer at the full portrait review. Contract and
   reasoning: AGENTS.md "Customer media in the gallery". */
(() => {
  const MAX = 7; // customer slides shown by default
  const CELLS = 8; // one spare cell: used only when it makes the desktop grid's total even (Scott, 8 Oct)
  const DESKTOP = window.matchMedia('(min-width: 1000px)');
  const gallery = document.querySelector('.shopify-section--main-product product-gallery');
  if (!gallery) return;
  const cells = Array.from(gallery.querySelectorAll('.product-gallery__media[data-bs-review]'));
  if (!cells.length) return;
  const configNode = document.querySelector('script[data-bs-gallery-reviews]');
  // metafield value: "auto", or review ids in the order they should lead ("123, 456");
  // a "-id" entry EXCLUDES that review (a poor video that would otherwise be auto-picked)
  let picks = []; const excluded = new Set();
  try {
    const raw = String(JSON.parse(configNode ? configNode.textContent : '""') || '').trim();
    raw.split(/[\s,]+/).forEach((token) => {
      if (/^-\d+$/.test(token)) excluded.add(token.slice(1));
      else if (/^\d+$/.test(token)) picks.push(token);
    });
  } catch (e) { picks = []; }
  const moreCell = gallery.querySelector('.product-gallery__media[data-bs-review="more"]');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const labels = { video: gallery.dataset.bsReviewVideoLabel || 'Customer video', image: gallery.dataset.bsReviewPhotoLabel || 'Customer photo' };
  const state = { items: [], candidates: null, remainingAfter: [], remaining: [], total: 0, seen: new Set() };

  /* --- choosing seven: hand-picked review ids first (in the listed order), then
     video, photo, video, photo... from this product's media reviews (four
     videos and three photos when both exist); when one kind runs out the
     other fills the rest */
  const choose = (all) => {
    const own = all.filter((item) => item.product && item.product.isCurrent && item.url && !excluded.has(item.reviewId));
    const used = new Set();
    const chosen = [];
    picks.forEach((id) => {
      const item = own.find((candidate) => candidate.reviewId === id && !used.has(candidate.key));
      if (item && chosen.length < CELLS) { chosen.push(item); used.add(item.key); }
    });
    const rest = own.filter((item) => !used.has(item.key));
    const videos = rest.filter((item) => item.type === 'video');
    const photos = rest.filter((item) => item.type !== 'video');
    let wantVideo = true;
    while (chosen.length < CELLS && (videos.length || photos.length)) {
      const pool = wantVideo ? (videos.length ? videos : photos) : (photos.length ? photos : videos);
      chosen.push(pool.shift());
      wantVideo = !wantVideo;
    }
    chosen.forEach((item) => used.add(item.key));
    return { chosen, remaining: own.filter((item) => !used.has(item.key)), total: own.length };
  };

  const forCell = (n, selector) => Array.from(gallery.querySelectorAll(`${selector}[data-bs-review="${n}"]`));

  const fillMore = (remaining, total) => {
    if (!moreCell) return;
    const next = remaining && remaining[0];
    const nodes = [moreCell, ...forCell('more', '.page-dots button'), ...forCell('more', '.product-gallery__thumbnail')];
    if (!next) { nodes.forEach((node) => { node.hidden = true; }); delete moreCell.dataset.bsReviewKey; return; }
    const poster = next.thumbnailUrl || next.url;
    [moreCell, ...forCell('more', '.product-gallery__thumbnail')].forEach((node) => { const img = node.querySelector('img'); if (img && img.getAttribute('src') !== poster) img.setAttribute('src', poster); });
    const count = moreCell.querySelector('[data-bs-review-more-count]');
    if (count) count.textContent = ''; // no number: the viewer shows a window of twelve at a time, so a "+94" would be a promise it cannot keep (Scott, 8 Oct)
    moreCell.dataset.bsReviewKey = next.key;
    moreCell.dataset.bsReviewType = 'more';
    nodes.forEach((node) => { node.hidden = false; });
  };

  // how many customer slides: seven, or on the desktop two-column grid whichever of
  // six / seven / eight makes the whole gallery (variant group + tail + customer
  // slides + see-all) an even count, since groups differ in size per variant
  // In the "grid highlight" desktop layout the FIRST image spans both columns, so the
  // pairs start from the second cell and the whole gallery must be ODD (Scott, 8 Oct);
  // a plain grid pairs from the first cell and must be even. Detect it from the
  // rendered width of the first two visible cells rather than a setting.
  const firstSpansRow = (visible) => {
    if (visible.length < 2) return false;
    const a = visible[0].getBoundingClientRect().width;
    const b = visible[1].getBoundingClientRect().width;
    return a > b * 1.5;
  };
  const countFor = (candidates, remainingAfter) => {
    let n = Math.min(MAX, candidates.length);
    if (!DESKTOP.matches || n === 0) return n;
    const visible = Array.from(gallery.querySelectorAll('.product-gallery__media')).filter((cell) => !cell.hidden && !cell.hasAttribute('data-bs-review'));
    const base = visible.length;
    const wantParity = firstSpansRow(visible) ? 1 : 0; // 1 = odd total, 0 = even total
    const more = (count) => (candidates.length - count + remainingAfter > 0 ? 1 : 0);
    if ((base + n + more(n)) % 2 === wantParity) return n;
    if (candidates.length > n && (base + n + 1 + more(n + 1)) % 2 === wantParity) return n + 1;
    return Math.max(0, n - 1);
  };

  const fill = (candidates, remainingAfter, total) => {
    state.candidates = candidates; state.remainingAfter = remainingAfter || []; state.total = total || 0;
    const shown = countFor(candidates, state.remainingAfter.length);
    const items = candidates.slice(0, shown);
    const remaining = [...candidates.slice(shown), ...state.remainingAfter];
    state.items = items; state.remaining = remaining;
    for (let n = 1; n <= CELLS; n += 1) {
      const item = items[n - 1];
      const cell = cells[n - 1];
      const nodes = [cell, ...forCell(n, '.page-dots button'), ...forCell(n, '.product-gallery__thumbnail')];
      if (!item) { nodes.forEach((node) => { node.hidden = true; }); continue; }
      const img = cell.querySelector('img');
      const poster = item.thumbnailUrl || item.url;
      if (img.getAttribute('src') !== poster) { img.setAttribute('src', poster); img.alt = `${labels[item.type === 'video' ? 'video' : 'image']} by ${item.reviewerName || 'a customer'}`; }
      cell.querySelector('.bs-review-slide__tag').textContent = labels[item.type === 'video' ? 'video' : 'image'];
      cell.dataset.bsReviewType = item.type === 'video' ? 'video' : 'image';
      cell.dataset.bsReviewKey = item.key;
      const thumb = forCell(n, '.product-gallery__thumbnail')[0];
      if (thumb) {
        const timg = thumb.querySelector('img');
        if (timg && timg.getAttribute('src') !== poster) timg.setAttribute('src', poster);
        thumb.classList.toggle('bs-review-thumb--video', item.type === 'video');
      }
      nodes.forEach((node) => { node.hidden = false; });
    }
    fillMore(state.remaining, state.total);
    observePlayback();
  };

  /* --- re-hide the unused cells after the vendor carousel re-applies `hidden`
     by child index on a variant change (same race as the marketing tail) */
  let rehideFrame = 0;
  const rehide = () => {
    if (rehideFrame) return;
    rehideFrame = requestAnimationFrame(() => {
      rehideFrame = 0;
      if (state.candidates || cells.some((c) => !c.hidden) || (moreCell && !moreCell.hidden)) fill(state.candidates || [], state.remainingAfter, state.total);
    });
  };
  DESKTOP.addEventListener('change', rehide);
  // the desktop parity count depends on how many OTHER cells are visible (the variant
  // group, the marketing tail), and those are revealed by other scripts on their own
  // schedule - the tail after its catalog fetch, the group after each variant change.
  // Re-balance whenever any non-review cell's `hidden` flips, so load order cannot
  // leave the grid odd (Scott saw 15 cells on a cold load, 8 Oct).
  if ('MutationObserver' in window) {
    new MutationObserver((records) => {
      if (records.some((r) => r.target instanceof Element && !r.target.hasAttribute('data-bs-review'))) rehide();
    }).observe(gallery, { attributes: true, attributeFilter: ['hidden'], subtree: true });
  }
  document.addEventListener('product:rerender', rehide, true);
  document.addEventListener('variant:change', rehide);

  /* --- video playback: materialise the <video> when a video slide comes near,
     play while it is mostly on screen, release the source when it leaves.
     Works for the mobile carousel and the desktop grid alike. */
  const ensureVideo = (cell) => {
    let video = cell.querySelector('video');
    if (video) return video;
    const item = state.items.find((candidate) => candidate.key === cell.dataset.bsReviewKey);
    if (!item || item.type !== 'video') return null;
    video = document.createElement('video');
    video.muted = true; video.loop = true; video.playsInline = true; video.setAttribute('playsinline', ''); video.setAttribute('muted', '');
    video.preload = 'metadata';
    video.poster = item.thumbnailUrl || '';
    video.src = item.url;
    video.setAttribute('aria-hidden', 'true');
    cell.querySelector('.bs-review-slide').insertBefore(video, cell.querySelector('.bs-review-slide__tag'));
    return video;
  };
  const releaseVideo = (cell) => {
    const video = cell.querySelector('video');
    if (!video) return;
    video.pause(); video.removeAttribute('src'); video.load(); video.remove();
  };
  let observer = null;
  const observePlayback = () => {
    if (!('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const cell = entry.target;
          if (cell.hidden || cell.dataset.bsReviewType !== 'video') { releaseVideo(cell); return; }
          if (!entry.isIntersecting) { releaseVideo(cell); return; }
          const video = ensureVideo(cell);
          if (!video) return;
          if (entry.intersectionRatio >= 0.5 && !reduceMotion) {
            cell.classList.add('is-playing');
            video.play().catch(() => { cell.classList.remove('is-playing'); });
          } else {
            video.pause(); cell.classList.remove('is-playing');
          }
        });
      }, { threshold: [0, 0.5], rootMargin: '200px 0px' });
    }
    cells.forEach((cell) => { observer.unobserve(cell); if (!cell.hidden) observer.observe(cell); });
  };

  /* --- maximise: the shared viewer (video-feedback) opens the full review */
  gallery.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bs-review-max], [data-bs-review-more]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const cell = button.closest('[data-bs-review]');
    const viewer = document.querySelector('video-feedback[data-review-continuation]');
    if (cell && viewer && typeof viewer.openReview === 'function') {
      // the slide's muted loop must not keep running under the open viewer; resume when it closes
      const playing = cells.filter((c) => c.classList.contains('is-playing'));
      playing.forEach((c) => { const v = c.querySelector('video'); if (v) v.pause(); });
      viewer.openReview(cell.dataset.bsReviewKey, button);
      const dialog = viewer.querySelector('dialog');
      if (dialog) dialog.addEventListener('close', () => playing.forEach((c) => { const v = c.querySelector('video'); if (v && c.classList.contains('is-playing')) v.play().catch(() => {}); }), { once: true });
    }
    if (typeof window.bsTrack === 'function') window.bsTrack('gallery_review_maximised', { type: cell && cell.dataset.bsReviewType, position: cell === moreCell ? 'more' : cells.indexOf(cell) + 1 });
  });
  // a tap on the slide itself must not reach the vendor's lightbox handlers
  [...cells, moreCell].filter(Boolean).forEach((cell) => cell.addEventListener('click', (event) => { if (!event.target.closest('[data-bs-review-max], [data-bs-review-more]')) event.stopPropagation(); }));

  /* --- analytics: each customer slide counted once per pageview when it is the selected one */
  const onSelect = (event) => {
    const slide = event.detail && event.detail.slide;
    const cell = slide && slide.closest && slide.closest('[data-bs-review]');
    gallery.toggleAttribute('data-bs-review-slide', Boolean(cell));
    if (!cell || cell === moreCell || state.seen.has(cell.dataset.bsReviewKey)) return;
    state.seen.add(cell.dataset.bsReviewKey);
    if (typeof window.bsTrack === 'function') window.bsTrack('gallery_review_slide_viewed', { type: cell.dataset.bsReviewType, position: cells.indexOf(cell) + 1 });
  };
  gallery.addEventListener('carousel:select', onSelect);
  gallery.addEventListener('carousel:change', onSelect);

  /* --- the pool: start the Loox fetch early (it is otherwise lazy near the
     review section far below), on the first gallery interaction or shortly after
     load, whichever comes first; the ready event carries the shared items */
  let requested = false;
  const request = () => {
    if (requested) return; requested = true;
    const source = document.querySelector('loox-api-reviews');
    if (source && typeof source.loadInitial === 'function') source.loadInitial();
  };
  document.addEventListener('blancspace:loox-review-media-ready', (event) => {
    const items = (event.detail && event.detail.items) || [];
    const picked = choose(items);
    fill(picked.chosen, picked.remaining, picked.total);
  });
  ['pointerdown', 'touchstart', 'keydown'].forEach((type) => gallery.addEventListener(type, request, { once: true, passive: true }));
  const idle = () => window.setTimeout(request, 2500);
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
})();
